const DATA_SAVED = "extragestor/actividades/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/actividades/RESET_DATA_SAVED";
const FETCH_LISTA = "extragestor/actividades/FETCH_LISTA";
const FETCH_DETALLE = "extragestor/actividades/FETCH_DETALLE";
const RESET_DETALLE = "extragestor/actividades/RESET_DETALLE";
const REMOVED = "extragestor/actividades/REMOVED";
const RESET = "extragestor/actividades/RESET";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  FETCH_LISTA,
  REMOVED,
  RESET,
  FETCH_DETALLE,
  RESET_DETALLE
};



// WEBPACK FOOTER //
// ./src/ducks/actividades/types.js